import * as React from "react";
import { Field, useField } from "formik";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import * as API from "@graylog/server-api";
import { Input } from "components/bootstrap";
import { FormikInput, MultiSelect } from "components/common";
import Spinner from "components/common/Spinner";
import FormikSwitch from "report/report-creation/FormikSwitch";
import PlusButton from "report/report-creation/common/PlusButton";
import ReportScheduling from "report/report-creation/overview/ReportScheduling";
import Separator from "report/report-creation/Separator";
const handleMultiSelectChange = (value) => value === "" ? [] : value.split(",");
const toSelectValue = (values) => Array.isArray(values) ? values.join(",") : "";
const fetchUsers = async () => {
  const users = await API.Users.listUsers(false, false);
  return users.users.map((user) => ({ label: `${user.full_name}`, value: user.username }));
};
const useUserOptions = () => useQuery({
  queryKey: ["users"],
  queryFn: fetchUsers
});
const Delivery = ({ editAllowed }) => {
  const { t } = useTranslation("enterprise_report");
  const { data: usersOptions, isLoading } = useUserOptions();
  const [{ value: deliveryActive }] = useField("delivery.active");
  return isLoading ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReportScheduling, { disabled: !deliveryActive, editAllowed }, ({ createScheduling }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(FormikSwitch, { label: t("delivery.schedule"), name: "delivery.active", disabled: !editAllowed }), /* @__PURE__ */ React.createElement(PlusButton, { title: t("delivery.add_schedule"), onClick: createScheduling, disabled: !editAllowed }))), /* @__PURE__ */ React.createElement(Separator, null), /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      id: "email_subject",
      name: "delivery.email_subject",
      label: t("delivery.email_subject"),
      help: t("delivery.email_subject_help"),
      required: true,
      disabled: !editAllowed
    }
  ), /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      id: "email_body",
      name: "delivery.email_body",
      type: "textarea",
      label: t("delivery.email_body"),
      help: t("delivery.email_body_help"),
      rows: 6,
      required: true,
      disabled: !editAllowed
    }
  ), /* @__PURE__ */ React.createElement(Field, { name: "delivery.user_receivers" }, ({ field: { name, value, onChange, onBlur }, meta: { error, touched } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      bsStyle: error && touched ? "error" : void 0,
      help: t("delivery.user_recipients_help"),
      error: error && touched ? error : void 0,
      id: name,
      label: t("delivery.user_recipients"),
      disabled: !editAllowed
    },
    /* @__PURE__ */ React.createElement(
      MultiSelect,
      {
        onBlur,
        onChange: (selectedReceivers) => onChange({
          target: {
            value: handleMultiSelectChange(selectedReceivers),
            name
          }
        }),
        options: usersOptions,
        inputId: name,
        addLabelText: t("delivery.type_username"),
        placeholder: t("delivery.type_username"),
        value: toSelectValue(value),
        disabled: !editAllowed
      }
    )
  )), /* @__PURE__ */ React.createElement(Field, { name: "delivery.email_receivers" }, ({ field: { name, value, onChange, onBlur }, meta: { error, touched } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      bsStyle: error && touched ? "error" : void 0,
      help: t("delivery.email_recipients_help"),
      error: error && touched ? error : void 0,
      id: name,
      label: t("delivery.email_recipients"),
      disabled: !editAllowed
    },
    /* @__PURE__ */ React.createElement(
      MultiSelect,
      {
        onBlur,
        onChange: (selectedReceivers) => onChange({
          target: {
            value: handleMultiSelectChange(selectedReceivers),
            name
          }
        }),
        options: [],
        inputId: name,
        addLabelText: t("delivery.add_email_label"),
        placeholder: t("delivery.type_email_address"),
        allowCreate: true,
        value: toSelectValue(value),
        disabled: !editAllowed
      }
    )
  )));
};
export default Delivery;
